import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { openEmailCaptureOverlay } from "web/redux/ducks/email-capture-overlay";
import PrimaryButton from "web/react/components/buttons/primary-button/primary-button";
import { gettext } from "web/script/modules/django-i18n";
import LeadLink from "web/react/components/lead-link/lead-link";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";

export function BuyOnStoreButton({
    leadUrl,
    leadLabel,
    openEmailCaptureOverlay,
    productId,
    reason,
}) {
    function onClickBuyNow() {
        if (!userProfiler.isLoggedIn() && environment.get("boomLeadSignupPrompt")) {
            openEmailCaptureOverlay({
                productId: productId,
                captureType: "signup_lead_save",
            });
        }
    }

    return (
        <LeadLink
            afterOnClick={onClickBuyNow}
            href={leadUrl}
            openInNewTab={true}
            productId={productId}
            reason={reason}
        >
            <PrimaryButton fullHeight fullWidth element="span">
                {leadLabel}
            </PrimaryButton>
        </LeadLink>
    );
}

BuyOnStoreButton.propTypes = {
    leadLabel: PropTypes.string,
    leadUrl: PropTypes.string.isRequired,
    openEmailCaptureOverlay: PropTypes.func,
    productId: PropTypes.string.isRequired,
    reason: PropTypes.string,
};

BuyOnStoreButton.defaultProps = {
    leadLabel: gettext("product.buy_area.shop_now"),
    reason: "buy-on-store-button",
};

export default withReduxProvider(
    connect(
        null,
        { openEmailCaptureOverlay }
    )(BuyOnStoreButton)
);
